import { useCallback } from 'react';
import { announce as announceImpl, type Politeness } from '@/components/Accessibility/LiveRegion';

export function useAnnouncer() {
  return useCallback((message: string, politeness: Politeness = 'polite') => {
    announceImpl(message, politeness);
  }, []);
}
